module.exports = __webpack_public_path__ + "static/media/RetScan_Eyecare_Solutions_Horizontal.4887cd47.png";